import ComponentModule from "@eisinc/Overrides/Components/AddressInfoDisplay";

export * from "@eisinc/Overrides/Components/AddressInfoDisplay";

export default ComponentModule;
